
<div>
  <slot></slot>
  <draggable v-model="optionElements" v-bind="{animation: 150}" class="matrix-input">
    <property-option
      v-for="(checkbox, i) in optionElements"
      :key="checkbox.client_id"
      :data-id="checkbox.client_id"
      :model="checkbox"
      :is-focused="isFocused(i)"
      v-on:blur="handleBlur(checkbox)"
      v-on:keydown:enter="handleEnter(checkbox)"
      v-on:remove="deleteChildProperty"
      v-on:paste:bulk="handlePasteBulk"
    ></property-option>
  </draggable>
  <div class="cta">
    <input
      type="button"
      value="Add new value"
      @click="add"
      class="btn grey-to-blue xs"
    >
  </div>

  <dynamic-child-paste-modal
    v-if="modalStateFor(pasteModalId, ModalStatus.Confirmation).isVisible"
    :state="modalStateFor(pasteModalId)"
    @toggle-modal="toggleModal"
    @paste="singlePaste"
    @bulk-add="bulkAdd"></dynamic-child-paste-modal>
</div>
